import Input from './Input';

class Validator {

    constructor(form, validationBag) {
        this.form = form;
        this.inputs = [];
        this.parse(validationBag);
    }

    parse(validationBag) {
        for(let field in validationBag) {
            this.inputs.push(new Input(this.form, validationBag[field], field));
        }
    }

    validate() {
        for (let input in this.inputs) {
            this.inputs[input].validate();
        }
    }

    passes() {
        this.validate(); // might need to return promise
        return ! this.form.errors.any();
    }

    fails() {
        return ! this.passes();
    }

}

export default Validator;


// WEBPACK FOOTER //
// ./resources/assets/js/src/core/Validator/Validator.js